import React from 'react';

type Props = {
  show: boolean;
  productName: string;
  onConfirm: () => void;
  onCancel: () => void;
};

const DeleteProductModal: React.FC<Props> = ({ show, productName, onConfirm, onCancel }) => {
  if (!show) return null;

  return (
    <>
      <div className="modal-backdrop fade show" onClick={onCancel} style={{ zIndex: 1040 }}></div>
      <div className="modal fade show" style={{ display: 'block', zIndex: 1050 }} tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content card-surface">
            <div className="modal-header border-bottom">
              <h5 className="modal-title">Delete Product</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onCancel}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>Do you want to delete this product?</p>
              <p className="fw-bold">{productName}</p>
              <p className="text-danger small">This action cannot be undone.</p>
            </div>
            <div className="modal-footer border-top">
              <button type="button" className="btn btn-outline-secondary" onClick={onCancel}>
                Cancel
              </button>
              <button type="button" className="btn btn-danger" onClick={onConfirm}>
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteProductModal;
